import React from 'react'
import MarketPlaceList from './MarketPlaceList'
import { Route, Routes } from 'react-router-dom'
import AddDescription from './AddDescription'

const Marketplace = () => {
    return (
        <div>
            <Routes>
                <Route path="/" element={<MarketPlaceList />} />
                <Route path="/AddDetail/:id" element={<AddDescription />} />
            </Routes>
        </div>
    )
}

export default Marketplace